var html = document.querySelector('.no-js');
html.classList.remove('no-js');
html.classList.add('js');


// WEBPACK FOOTER //
// ./resources/js/components/no-js.js